import { safeHTML } from '../../../../../utils/safeHTML';
import React from 'react';

export default function ItemTitle({ domElementsRef, titleValue }) {
  return (
    titleValue && (
      <div ref={(ref) => (domElementsRef.current.title = ref)} className={'my-gift__filter-title'}>
        {safeHTML(titleValue)}
      </div>
    )
  );
}
